/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamExamidClasses200,
  GetApiV1ExamExamidClasses401,
  GetApiV1ExamExamidClasses500,
  GetApiV1ExamExamidClassesPathParams,
  GetApiV1ExamExamidClassesQueryParams,
  GetApiV1ExamExamidClassesQueryResponse,
} from "../../types/examEvaluationController/GetApiV1ExamExamidClasses.ts";
import { examClassGridItemViewModelSchema } from "../examClassGridItemViewModelSchema.ts";

export const getApiV1ExamExamidClassesPathParamsSchema = z.object({
  examId: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1ExamExamidClassesPathParams>;

export const getApiV1ExamExamidClassesQueryParamsSchema = z.object({
  poloId: z.optional(z.coerce.number().int()),
  courseId: z.optional(z.coerce.number().int()),
  status: z.optional(z.coerce.number().int()),
  classStudentId: z.optional(z.coerce.number().int()),
  moduleId: z.optional(z.coerce.number().int()),
  dateStart: z.optional(z.string().datetime()),
  dateEnd: z.optional(z.string().datetime()),
  companyId: z.optional(z.coerce.number().int()),
  pageNumber: z.coerce.number().int().default(1),
  pageSize: z.coerce.number().int().default(20),
  sortField: z.optional(z.string()),
  sortDirection: z.optional(z.string()),
}) as unknown as ToZod<GetApiV1ExamExamidClassesQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamExamidClasses200Schema = z.array(
  z.lazy(() => examClassGridItemViewModelSchema),
) as unknown as ToZod<GetApiV1ExamExamidClasses200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamExamidClasses401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamExamidClasses401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamExamidClasses500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamExamidClasses500>;

export const getApiV1ExamExamidClassesQueryResponseSchema = z.lazy(
  () => getApiV1ExamExamidClasses200Schema,
) as unknown as ToZod<GetApiV1ExamExamidClassesQueryResponse>;
